<script>
import Button from "@/components/button";

export default {
  components: {Button},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    add: {
      type: Object,
      default: () => {
        return {}
      },
    },
    export: {
      type: Object,
      default: null
    },
    buttons: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  methods: {
    isAddable: function() {
      return this.add !== null && this.add.link !== "";
    },

    isExportable: function() {
      return this.export !== null;
    },
  
    navigateTo: function(link, params = null) {

      if(link) {

        let uri = {
          name: link,
        };

        if(params !== null) {
          uri[params] = params;
        }

        this.$router.push(this.$route.query.redirectFrom || uri);

      } else {
        this.$emit('click');
      }
    },
  },
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0 font-size-18">{{ title }}</h4>
        
        <div class="page-title-right">
          <div v-if="items.length > 0">
            <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
          </div>
          <div v-else>
            <b-form inline class="row gy-2 gx-3 align-items-end">
              <div v-for="(button, index) in buttons" :key="index" class="col-sm-auto">
                  <Button :icon="button.icon" 
                    :buttonType="button.type ? button.type : 'button'"
                    @click="navigateTo(button.link)"
                    :titleLocate="button.title" />
              </div>

              <div v-if="isAddable()" v-show="isAddable()" class="col-sm-auto">
                <Button :icon="add.icon" 
                  :buttonType="'button'"
                  @click="navigateTo(add.link)"
                  :titleLocate="add.title" />
              </div>
              <div v-show="isExportable()" class="col-sm-auto">
                <Button :icon="'bx bx-export'" 
                  :buttonType="'button'"
                  @click="navigateTo(this.export.link)"
                  :variant="'success'"
                  :titleLocate="'general.export'" />
              </div>
            </b-form >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
